import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IConfirmationDialogOptions } from './confirmation-dialog-options.interface';
// import { UtilsService } from '../../index';

@Component({
  selector: 'app-confirmation-dialog',
  // encapsulation: ViewEncapsulation.None,
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.scss']
})

export class ConfirmationDialogComponent implements OnInit, OnDestroy {
  dialog: MatDialogRef<any>;
  modalOptions!: IConfirmationDialogOptions;

  constructor(
    public dialogRef: MatDialogRef<any>,
    // private _utilsService: UtilsService
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.modalOptions.title = this.modalOptions.title ?? 'Confirmacion';
    this.modalOptions.message = this.modalOptions.message ?? 'Esta seguro?';
    this.modalOptions.message = this.modalOptions.message.replace("\n", '<br>');
    this.modalOptions.message = this.modalOptions.message.replace('\n', '<br>');
    this.modalOptions.yesButtonLabel = this.modalOptions.yesButtonLabel ?? 'Si';
    this.modalOptions.noButtonLabel = this.modalOptions.noButtonLabel ?? 'No';
    // this._utilsService.disableBodyScroll();
  }

  ngOnDestroy() {
    // this._utilsService.enableBodyScroll();
  }
}
